/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Lpdealoverviewcontent_Adduptofivesections8Inputs */

const en_coinvestments_lpdealoverviewcontent_adduptofivesections8 = /** @type {(inputs: Coinvestments_Lpdealoverviewcontent_Adduptofivesections8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add up to five sections`)
};

/**
* | output |
* | --- |
* | "Add up to five sections" |
*
* @param {Coinvestments_Lpdealoverviewcontent_Adduptofivesections8Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_lpdealoverviewcontent_adduptofivesections8 = /** @type {((inputs?: Coinvestments_Lpdealoverviewcontent_Adduptofivesections8Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Lpdealoverviewcontent_Adduptofivesections8Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_lpdealoverviewcontent_adduptofivesections8(inputs)
});
export { coinvestments_lpdealoverviewcontent_adduptofivesections8 as "coInvestments_lpDealOverviewContent_addUpToFiveSections" }